import { useCallback } from 'react';
// Hooks
import { useAppContext, useOnboardingContext } from 'hooks';
// Helpers
import {
  clearPpvBuyStreamIdFromLocalStorage,
  setPpvBuyStreamIdToLocalStorage,
} from 'helpers/storage';

export function useGuestPpvBuyFlow() {
  const { setSignUpModalVisibility, setLoginModalVisibility } = useAppContext();
  const { setIsPPVBuyFlow } = useOnboardingContext();

  const startGuestPpvBuy = useCallback(
    (streamId: string) => {
      setPpvBuyStreamIdToLocalStorage(streamId);
      setIsPPVBuyFlow(true);
      setSignUpModalVisibility(true);
    },
    [setIsPPVBuyFlow, setSignUpModalVisibility]
  );

  const cancelGuestPpvBuy = useCallback(() => {
    clearPpvBuyStreamIdFromLocalStorage();
    setIsPPVBuyFlow(false);
  }, [setIsPPVBuyFlow]);

  const completeGuestPpvBuy = useCallback(() => {
    clearPpvBuyStreamIdFromLocalStorage();
    setIsPPVBuyFlow(false);
    setLoginModalVisibility(false);
    setSignUpModalVisibility(false);
  }, [setIsPPVBuyFlow, setLoginModalVisibility, setSignUpModalVisibility]);

  return {
    startGuestPpvBuy,
    cancelGuestPpvBuy,
    completeGuestPpvBuy,
  };
}
